import type { ScreenerColumn, ScreenerData } from "epsm-api-types/models";
import Papa from "papaparse";
import { columnValueFormatter } from "@/components/widgets/Monitor/lib/helpers/columnValueFormatter";

export interface FieldParams {
	header: string;
	column: ScreenerColumn;
}

function flattenObject(
	obj: Record<string, unknown>,
	parentKey = "",
	result: Record<string, unknown> = {},
): Record<string, unknown> {
	for (const key in obj) {
		if (Object.hasOwn(obj, key)) {
			const newKey = parentKey ? `${parentKey}.${key}` : key;
			const value = obj[key];

			if (
				typeof value === "object" &&
				value !== null &&
				!Array.isArray(value) &&
				!(value instanceof Date)
			) {
				flattenObject(value as Record<string, unknown>, newKey, result);
			} else {
				result[newKey] = value;
			}
		}
	}
	return result;
}

export const generateCSV = ({
	data,
	params,
}: {
	data: ScreenerData[];
	params?: Record<keyof ScreenerData, FieldParams>;
}) => {
	const formattedData = data.map((item) => flattenObject(item));

	if (!params) {
		return Papa.unparse(formattedData);
	}

	function getFormattedRow(
		params: Record<string, FieldParams>,
		row: Record<string, unknown>,
	): Record<string, unknown> {
		const formattedRow: Record<string, unknown> = {};

		for (const key of Object.keys(params)) {
			const value = key in row ? row[key] : undefined;
			const { header, column } = params[key];
			formattedRow[header] = columnValueFormatter(value, column);
		}
		return formattedRow;
	}

	const formattedCSVData = formattedData.map((row) =>
		getFormattedRow(params, row),
	);

	return Papa.unparse(formattedCSVData);
};
